import { IntegrationInitializationModal } from '../IntegrationInitializationModal'
import { IntegrationNotice } from '../IntegrationNotice'
import { useModals } from 'almanac-ui/Modal'
import Styles from '../IntegrationInitializationModal.module.scss'
import { Facebook } from 'almanac-ui/icons'
import { IntegrationInitializationDrawer } from '../IntegrationInitializationDrawer'
import { InitializationProps } from '../types'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

export const META_ADS_CONNECTION_GUIDE_LINK =
  'https://help.blaze.ai/en/articles/9556888-connect-blaze-to-facebook-business'

export const MetaAdsNotice = () => (
  <IntegrationNotice
    connectionGuideLink={META_ADS_CONNECTION_GUIDE_LINK}
    message={
      <div className={Styles.message}>
        To post ads on Facebook, Instagram, and associated accounts or pages, you need to connect to Meta's platform
        through <b>Meta Business Suite</b> or <b>Ads Manager</b>.
        <br />
        <ul className={Styles.list}>
          <li>Create a Meta Business account (if you don't have one already)</li>
          <li>Link your Facebook page and Instagram account in settings</li>
          <li>Set up a payment method in Ads Manager.</li>
        </ul>
        <div className={Styles.note}>If you are not sure if you have the right setup, review our guide:</div>
      </div>
    }
  />
)

const MetaAdsInitialization = ({ useDrawer = false }: InitializationProps) => {
  const { closeModal } = useModals()
  const { initiateOauth } = useInitiateOauth()

  const sharedProps = {
    notice: <MetaAdsNotice />,
    providerName: 'Meta Ads',
    onClose: closeModal,
    icon: <Facebook size={32} />,
    title: 'Connect Facebook Business Account',
    onConfirm: () => initiateOauth(ExternalIntegrationEnum.MetaAds),
    primaryButtonText: 'Go to Meta Business',
  }

  return useDrawer ? (
    <IntegrationInitializationDrawer {...sharedProps} />
  ) : (
    <IntegrationInitializationModal {...sharedProps} />
  )
}

export default MetaAdsInitialization
